import React, { Fragment } from 'react';
import { ShowButton, Filter, TextInput, Datagrid, TextField, DateField, SelectInput } from 'react-admin';
import LockWalletsButton from './LockWalletsButton';
import { coreWalletStatusForSelection, coreWalletTypesForSelection } from './WalletConstants';
import WalletListActions from './WalletListActions';
import TList from '../../components/wrapper/TList';

const WalletBulkActionButtons = props => (
	<Fragment>
		<LockWalletsButton {...props} />
	</Fragment>
);
const WalletFilter = ({ hideOwnerFilter, ...props }) => (
	<Filter {...props}>
		{!hideOwnerFilter && (
			<TextInput
				alwaysOn
				resettable
				label="resources.wallets.filters.ownerType"
				source="ownerType"
			/>
		)}
		{!hideOwnerFilter && (
			<TextInput alwaysOn resettable label="resources.wallets.filters.ownerId" source="ownerId" />
		)}
		<SelectInput
			resettable
			label="resources.wallets.filters.type"
			source="walletType"
			choices={coreWalletTypesForSelection}
		/>
		<SelectInput
			resettable
			label="resources.wallets.filters.status"
			source="walletStatus"
			choices={coreWalletStatusForSelection}
		/>
		<TextInput
			resettable
			label="resources.wallets.filters.externalReferenceId"
			source="externalReferenceId"
		/>
	</Filter>
);

const WalletList = ({ hideOwnerFilter, ...props }) => (
	<TList
		{...props}
		sort={{ field: 'id', order: 'DESC' }}
		actions={hideOwnerFilter ? undefined : <WalletListActions />}
		bulkActionButtons={<WalletBulkActionButtons />}
		filters={<WalletFilter hideOwnerFilter={hideOwnerFilter} />}
	>
		<Datagrid>
			<ShowButton/>
			<TextField source="walletId" sortBy="id" />
			<DateField source="creationDateTime" showTime sortable={false} />
			<TextField source="walletType" sortable={false} />
			<TextField source="walletStatus" sortable={false} />
			<TextField source="externalReferenceId" sortable={false} />
		</Datagrid>
	</TList>
);

export default WalletList;
